import {
    PURCHASE_INSUFFICIENT_FUNDS,
} from "opp-api-lib-js";

export const BASE_10 = 10;
export const DOLLAR_IN_CENTS = 100;
export const SERVER_ERROR = "SERVER_ERROR";

export {
    PURCHASE_INSUFFICIENT_FUNDS,
};



// WEBPACK FOOTER //
// ./src/constants.ts